import { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const Grid = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ color = 'white', width = '24', height = '24', ...props }, ref) => {
    return (
      <SvgIcon
        ref={ref}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        sx={{
          backgroundColor: (theme) => theme.palette.badge5,
          borderRadius: 4,
          padding: '2px',
          width,
          height,
        }}
        {...props}
      >
        <rect x="8.16455" y="8.3562" width="8.33874" height="7.91039" rx="1" fill={color} />
        <rect x="10.3979" y="14.3613" width="3.87278" height="4.15807" rx="0.5" fill={color} />
        <rect x="11.314" y="18.9558" width="2.03992" height="4.41528" rx="0.5" fill={color} />
        <rect x="9.81982" y="4.67505" width="1.49488" height="4.55797" rx="0.5" fill={color} />
        <rect x="13.354" y="4.67505" width="1.49488" height="4.55797" rx="0.5" fill={color} />
      </SvgIcon>
    );
  }
);

Grid.displayName = 'Grid';
